module.exports = __webpack_public_path__ + "img/Structure_of_Trainings.bae4af2f.png";